import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MapPin } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Field, ImagesInput, PageHeader, Panel } from "../components/common";
import { Textarea } from "../components/ui/textarea";
import { Switch } from "../components/ui/switch";
import { Button } from "../components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";

const getPos = () => new Promise((res) => {
  if (!navigator.geolocation) return res(null);
  navigator.geolocation.getCurrentPosition((p) => res({ lat: p.coords.latitude, lng: p.coords.longitude }), () => res(null), { timeout: 8000 });
});

export default function NewAlert() {
  const nav = useNavigate();
  const [cats, setCats] = useState([]);
  const [categoria, setCategoria] = useState("");
  const [severita, setSeverita] = useState("attenzione");
  const [testo, setTesto] = useState("");
  const [imgs, setImgs] = useState([]);
  const [gps, setGps] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => { api("/alert-categories").then((d) => setCats(d.categories || [])).catch(() => {}); }, []);
  const cat = cats.find((c) => (c.nome || c) === categoria);

  const submit = async () => {
    if (!categoria) return toast.error("Seleziona il tipo di alert");
    setLoading(true);
    try {
      const loc = gps ? await getPos() : null;
      await api("/alerts", { method: "POST", body: { categoria, severita, messaggio: testo, immagine: imgs[0] || "", lat: loc?.lat ?? null, lng: loc?.lng ?? null } });
      toast.success(`Alert inviato${loc ? " · posizione allegata" : ""}`);
      nav("/avvisi");
    } catch (e) { toast.error(e.message); } finally { setLoading(false); }
  };

  return (
    <div className="max-w-2xl">
      <PageHeader subtitle="Avviso operativo immediato" title="Invia Alert" />
      <Panel className="space-y-6">
        <Field label="Tipo di alert">
          <Select value={categoria} onValueChange={setCategoria}>
            <SelectTrigger data-testid="alert-category-select"><SelectValue placeholder="Seleziona il tipo..." /></SelectTrigger>
            <SelectContent>{cats.map((c) => { const n = c.nome || c; return <SelectItem key={n} value={n}>{n}</SelectItem>; })}</SelectContent>
          </Select>
        </Field>
        {cat?.destinatari && <p className="text-xs text-slate-500 -mt-3">Destinatari: {[].concat(cat.destinatari).join(", ")}</p>}
        <div className="flex gap-2">{[["attenzione", "Attenzione"], ["critico", "Critico"]].map(([v, l]) => (
          <button key={v} onClick={() => setSeverita(v)} className={`px-4 py-2 rounded-full text-sm font-semibold border transition-colors ${severita === v ? (v === "critico" ? "bg-[var(--red)] text-white border-[var(--red)]" : "bg-amber-500 text-white border-amber-500") : "bg-white"}`} data-testid={`alert-severity-${v}`}>{l}</button>))}
        </div>
        <div className="flex items-center justify-between rounded-xl bg-[var(--teal-soft)] p-4">
          <div className="flex items-center gap-3"><MapPin className="w-5 h-5 text-[var(--teal)]" /><div><p className="font-medium text-sm">Invia coordinate GPS</p><p className="text-xs text-slate-500">{gps ? "La posizione verrà rilevata e allegata all'alert" : "L'alert verrà inviato senza posizione"}</p></div></div>
          <Switch checked={gps} onCheckedChange={setGps} data-testid="alert-gps-switch" />
        </div>
        <Field label="Messaggio (facoltativo)"><Textarea value={testo} onChange={(e) => setTesto(e.target.value)} placeholder="Aggiungi dettagli (facoltativo)..." data-testid="alert-message-input" /></Field>
        <Field label="Immagine (facoltativa, compressa automaticamente)"><ImagesInput value={imgs} onChange={setImgs} testid="alert-image-input" /></Field>
        <Button onClick={submit} disabled={loading} className="rounded-full bg-[var(--red)] hover:bg-[#c10024] px-8" data-testid="alert-submit-button">Invia Alert</Button>
      </Panel>
    </div>
  );
}
